import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Para capturar el token desde la URL
//import { resetPassword } from '../services/authService';
import { resetPassword } from '../../services/authService';

const ResetPassword = () => {
  const { token } = useParams(); // Captura el token de la URL
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
        setError('Las contraseñas no coinciden.');
        return;
    }

    try {
        // Llamar a la función resetPassword con el token y la nueva contraseña
        const response = await resetPassword(token, newPassword);

        setSuccessMessage('¡Contraseña cambiada con éxito! Redirigiendo al inicio de sesión...');
        setError('');

        // Redirigir al inicio de sesión después de unos segundos
        setTimeout(() => {
            navigate('/');
        }, 3000);
    } catch (error) {
        setError(error.message || 'Ocurrió un error al cambiar la contraseña.');
    }
};

  return (
    <div style={{ maxWidth: '400px', margin: 'auto', padding: '1rem' }}>
      <h2>Restablecer Contraseña</h2>
      {error && <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>}
      {successMessage && <div style={{ color: 'green', marginBottom: '1rem' }}>{successMessage}</div>}
      {!successMessage && (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="newPassword">Nueva Contraseña:</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="confirmPassword">Confirmar Contraseña:</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit">Cambiar Contraseña</button>
        </form>
      )}
    </div>
  );
};

export default ResetPassword;
